import { ArrowUpIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ArrowUp = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ArrowUpIcon size={Sizes[size]} color={fill} {...rest} />;
};

ArrowUp.displayName = 'ArrowUp';
